globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.TopBar = (function() {

  function TopBar() {
    this.init();
  }

  TopBar.init = function(){
    return new TopBar();
  }

  TopBar.prototype = {
    init: function($topBarItem) {
      var _this = this;

      if($topBarItem) {
        _this.initTopBarItem($topBarItem);
      } else {
        $('.top-bar-item').each(function(){
          _this.initTopBarItem($(this));
        });
      }
    },
    initTopBarItem: function($topBarItem) {
      var _this = this;

      if($topBarItem.find('.top-bar-tooltip-toggle').length) {
        _this.initTooltip($topBarItem);
      }
    },

    initTooltip: function($topBarItem) {
      var $toggle = $topBarItem.find('.top-bar-tooltip-toggle');
      var $target = $($toggle.data('target'));
      var position = $toggle.data('position');
      var refreshTooltipPositionTimeout;
      var $tooltip;

      function refreshTooltipPosition() {

        refreshTooltipPositionTimeout = setTimeout(function() {
          var offset = $target.offset();

          $tooltip.css('top', offset.top + $target.height() - 4);

          if(position == 'right') {
            $tooltip.css('right', $(window).width() - (offset.left + $target[0].offsetWidth));
          } else {
            $tooltip.css('left', offset.left);
          }
        }, 400);
      }

      var dataText = $toggle.data('html');
      var dataJson = $toggle.data('json');

      if(dataJson) {
        var today = new Date();
        $tooltip = $('<div class="top-bar-tooltip-info-wrapper"><div class="top-bar-tooltip-info">' + dataJson[today.getDay()][today.getDay()] + '</div></div>');
      }

      if(dataText) {
        $tooltip = $('<div class="top-bar-tooltip-info-wrapper"><div class="top-bar-tooltip-info">' + dataText + '</div></div>');
      }

      if(!$tooltip) return false;

      refreshTooltipPosition();

      $tooltip.appendTo($('body'));

      var hovered;

      $target.on('mouseenter', function() {
        $tooltip.show();
      }).on('mouseleave', function() {
        setTimeout(function() {
          if(!hovered) {
            $tooltip.hide();
          }
        }, 10);
      });

      $tooltip.on('mouseenter', function() {
        if(!hovered) {
          hovered = true;
        }
      }).on('mouseleave', function() {
        hovered = false;
        $(this).hide();
      });

      $(window).on('resize, scroll', function() {
        clearTimeout(refreshTooltipPositionTimeout);
        refreshTooltipPosition();
      });
    },
  }

  return TopBar;
})();
